import { OTA_Vehicle } from "./ota_vehicle.model";
import { OTA_RentalRate } from "./ota_rentalrate.model";
import { OTA_TotalCharge } from "./ota_totalcharge.model";
import { OTA_PricedEquip } from "./ota_pricedequip.model";
import { OTA_Fee } from "./ota_fee.model";

export class OTA_VehAvailCore {
    public status: string;
    public vehicle = new OTA_Vehicle();
    public rentalRate = new OTA_RentalRate();
    public totalCharge = new OTA_TotalCharge();
    public pricedEquips = new Array<OTA_PricedEquip>();
    public fees = new Array<OTA_Fee>();
}